// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--3WYrT","Overdue":"Overdue--1-gEo","Arrow":"Arrow--231vX"};